import { filterEmpty, Select, tryParseJSONArray } from '@fox/atoms';
import { IQuestionAnswer } from '../../form-root/contracts';
import { FormRenderMode, useFormRuntimeContext } from '../../form-runtime-context';
import { QuestionChoice } from './contracts';

interface IDropdownAnswerProps {
	options: QuestionChoice[];
	questionName: string;
	allowMulti: boolean;
	allowOther: boolean;
}

export const DropdownAnswer = (props: IDropdownAnswerProps) => {
	const { questionName, options, allowMulti, allowOther } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();

	const questionAnswer = getAnswer(questionName);

	const choiceOptions = [
		...(options || []),
		...(allowOther
			? [
					{
						value: '__other',
						displayName: '__other'
					}
				]
			: [])
	];

	return allowMulti ? (
		<Select<QuestionChoice, true, true, false>
			multiple={true}
			size="small"
			disableClearable
			value={filterEmpty(
				tryParseJSONArray<string>(questionAnswer?.answer?.answerJson, []).map(v => choiceOptions.find(o => o.displayName === v))
			)}
			options={choiceOptions}
			onChange={(_, selectedOptions) => {
				if (formRenderMode === FormRenderMode.design) {
					return;
				}
				const selectedValues = selectedOptions.map(option => option.displayName);

				const newAnswer: IQuestionAnswer = {
					questionName: questionName,
					answer: { answerJson: JSON.stringify(selectedValues ?? []) }
				};

				answerQuestion(newAnswer);
			}}
			getOptionLabel={option => (option.displayName === '__other' ? 'Other' : (option.displayName ?? ''))}
		/>
	) : (
		<Select<QuestionChoice, false, true, false>
			multiple={false}
			size="small"
			disableClearable
			value={choiceOptions.find(o => o.displayName === (questionAnswer?.answer?.answerString ?? ''))}
			options={choiceOptions}
			onChange={(_, selectedOptions) => {
				if (formRenderMode === FormRenderMode.design) {
					return;
				}

				const newAnswer: IQuestionAnswer = {
					questionName: questionName,
					answer: { answerString: selectedOptions.displayName }
				};

				answerQuestion(newAnswer);
			}}
			getOptionLabel={option => (option.displayName === '__other' ? 'Other' : (option.displayName ?? ''))}
		/>
	);
};
